import { firstFieldError, normalizeCatalogError } from '@/features/catalog/shared/catalogErrors.mjs'

function formatRetryMessage(message, retryAfterSeconds) {
  if (!Number.isFinite(retryAfterSeconds) || retryAfterSeconds <= 0) {
    return message
  }

  return `${message} Спробуйте ще раз через ${retryAfterSeconds} сек.`
}

export function normalizeApiError(error, options = {}) {
  const normalized = normalizeCatalogError(error, options)
  const retryAfterSeconds = Number(normalized.details?.retry_after_seconds)
  let message = normalized.message

  if (normalized.status === 429) {
    message = formatRetryMessage(message, retryAfterSeconds)
  }

  return {
    ...normalized,
    message,
    retryAfterSeconds: Number.isFinite(retryAfterSeconds) ? retryAfterSeconds : null,
  }
}

export function getFirstFieldError(fieldErrors, fieldName) {
  return firstFieldError(fieldErrors, fieldName)
}
